import { render, staticRenderFns } from "./proReviewCpts.vue?vue&type=template&id=51689d1a&scoped=true&"
import script from "./proReviewCpts.vue?vue&type=script&lang=js&"
export * from "./proReviewCpts.vue?vue&type=script&lang=js&"
import style0 from "./proReviewCpts.vue?vue&type=style&index=0&id=51689d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51689d1a",
  null
  
)

export default component.exports